import { ChangeEvent, JSX } from 'react';
import { useParams } from 'react-router-dom';
import cardStyle from './card.module.scss';
import { toastrInfo } from '../../../../common/toastr/info/toastr-options-info';
import { useAppDispatch } from '../../../../featchers/hooks';
import { deleteCard, editCard } from '../../../../featchers/slices/boardSlice';
import { toastrSuccess } from '../../../../common/toastr/success/toastr-options-success';

interface props {
  listId: number | undefined;
  cardId: number | undefined;
  setIsNameCard: React.Dispatch<React.SetStateAction<boolean>>;
  nameCard: string;
  setNameCard: React.Dispatch<React.SetStateAction<string>>;
  oldValue: string | undefined;
  infoCard: string;
  isCompleted: boolean;
}

export function EditNameCard({
  cardId,
  listId,
  setIsNameCard,
  nameCard,
  setNameCard,
  oldValue,
  infoCard,
  isCompleted,
}: props): JSX.Element {
  const dispatch = useAppDispatch();
  const { boardId } = useParams();

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    if (infoCard === 'description') {
      setNameCard(event.target.value);
    } else if (infoCard === 'title' && /^[a-zA-Zа-щА-ЩіІїЇєЄЯяЫыґҐ0-9 `,._-]*$/.test(event.target.value)) {
      setNameCard(event.target.value);
    }
  };

  const editName = async (): Promise<void> => {
    if (nameCard.trim() === '' && infoCard === 'title') {
      toastrInfo("Ім'я картки не повинно бути пустим", 'Інформація');
      if (!oldValue && boardId && cardId) dispatch(deleteCard({ boardId, cardId }));
      if (oldValue) {
        setNameCard(oldValue);
        setIsNameCard(true);
      }
      return;
    }
    if (nameCard.trim() === oldValue?.trim()) {
      setIsNameCard(true);
      return;
    }
    const newTitleForServer = isCompleted && infoCard === 'title' ? `${nameCard}|DONE|` : nameCard;
    try {
      if (boardId && cardId && listId)
        await dispatch(editCard({ boardId, cardId, listId, nameCard: newTitleForServer, infoCard })).unwrap();
      toastrSuccess('Дані збережено', 'Успіх');
    } catch (error) {
      setNameCard(oldValue!);
    } finally {
      setIsNameCard(true);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    if (event.key === 'Enter') {
      editName();
    }
  };

  return (
    <textarea
      placeholder={infoCard === 'description' ? 'Тут може бути опис карточки, який підтримує markdown...' : ' '}
      value={nameCard}
      className={cardStyle.input}
      onChange={handleChange}
      onBlur={editName}
      onKeyDown={handleKeyDown}
      onClick={(e): void => {
        e.preventDefault();
        e.stopPropagation();
      }}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
    />
  );
}
